import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;
const apiKey = process.env.VUE_APP_API_KEY;
const accountId = process.env.VUE_APP_ACCOUNT_ID;

export const GetEntities = () => {
    return axios.get(apiUrl+"entities").then((response) => response).catch(error => console.log(error));
};
export const GetSingleEntities = (entity_id) => {
    return axios.get(`${apiUrl}entities/${entity_id}`).then((response) => response).catch(error => console.log(error));
};
export const GetHomeText = () => {
    return axios.get(apiUrl+"home/text").then((response) => response).catch(error => console.log(error));
};